export const profileGiftsSelfPath = 'profile-gifts-self-modal'
